import { render, staticRenderFns } from "./promoMemberAssign.vue?vue&type=template&id=531dc342&lang=pug"
import script from "./promoMemberAssign.vue?vue&type=script&lang=js"
export * from "./promoMemberAssign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports